var Pikaday = require('pikaday');

export class PikadayService {
    public init(item: HTMLElement) {
        return new Pikaday({
            field: item,
            format: 'YYYY-MM-DD',
            firstDay: 1,
            disableWeekends: false,
            i18n: {
                previousMonth : 'Poprzedni miesiąc',
                nextMonth     : 'Następny miesiąc',
                months        : ['Styczeń','Luty','Marzec','Kwiecień','Maj','Czerwiec','Lipiec','Sierpień','Wrzesień','Październik','Listopad','Grudzień'],
                weekdays      : ['Niedziela','Poniedziałek','Wtorek','Środa','Czwartek','Piątek','Sobota'],
                weekdaysShort : ['Nie','Pon','Wto','Śr','Czw','Pią','Sob']
            }
        });
    }
}